"use client"
import {
  shouldShowFallbackImage,
  useImage
} from "./chunk-V6HTI25P.mjs";

// src/image.tsx
import {
  forwardRef,
  omitThemeProps,
  ui,
  useComponentStyle
} from "@yamada-ui/core";
import { cx } from "@yamada-ui/utils";
import { isValidElement, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var Image = forwardRef((props, ref) => {
  const [styles, { size, ...mergedProps }] = useComponentStyle("Image", props);
  const {
    src,
    srcSet,
    className,
    boxSize = size,
    crossOrigin,
    fallback,
    fallbackStrategy = "beforeLoadOrError",
    fit: objectFit,
    ignoreFallback: _ignoreFallback,
    loading,
    referrerPolicy,
    onError,
    onLoad,
    ...rest
  } = omitThemeProps(mergedProps);
  const ignoreFallback = loading != null || _ignoreFallback || !fallback;
  const css = useMemo(
    () => ({ ...styles, boxSize, objectFit }),
    [styles, boxSize, objectFit]
  );
  const status = useImage({ ...props, ignoreFallback });
  const isFallbackImage = shouldShowFallbackImage(status, fallbackStrategy);
  if (isFallbackImage) {
    if (isValidElement(fallback)) {
      return fallback;
    } else {
      return /* @__PURE__ */ jsx(
        ui.img,
        {
          ref,
          src: fallback,
          className: cx("ui-image--fallback", className),
          __css: css,
          ...ignoreFallback ? { ...rest, onError, onLoad } : rest
        }
      );
    }
  }
  return /* @__PURE__ */ jsx(
    ui.img,
    {
      ref,
      src,
      srcSet,
      className: cx("ui-image", className),
      crossOrigin,
      loading,
      referrerPolicy,
      __css: css,
      ...ignoreFallback ? { ...rest, onError, onLoad } : rest
    }
  );
});
Image.displayName = "Image";
Image.__ui__ = "Image";

export {
  Image
};
//# sourceMappingURL=chunk-P7ONJIWD.mjs.map